"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _stripDiacritics = _interopRequireDefault(require("./stripDiacritics"));
function filterOptions(options, filterValue, excludeOptions, props) {
  var _this = this;
  var localFilterValue = filterValue;
  var localExcludeOptions = excludeOptions;
  if (props.ignoreAccents) {
    localFilterValue = (0, _stripDiacritics["default"])(localFilterValue);
  }
  if (props.ignoreCase) {
    localFilterValue = localFilterValue.toLowerCase();
  }
  if (localExcludeOptions) localExcludeOptions = localExcludeOptions.map(function (i) {
    return i[props.valueKey];
  });
  return options.filter(function (option) {
    if (localExcludeOptions && localExcludeOptions.indexOf(option[props.valueKey]) > -1) return false;
    if (props.filterOption) return props.filterOption.call(_this, option, localFilterValue);
    if (!localFilterValue) return true;
    var valueTest = String(option[props.valueKey]);
    var labelTest = String(option[props.labelKey]);
    if (props.ignoreAccents) {
      if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics["default"])(valueTest);
      if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics["default"])(labelTest);
    }
    if (props.ignoreCase) {
      if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
      if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
    }
    return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, localFilterValue.length) === localFilterValue || props.matchProp !== 'value' && labelTest.substr(0, localFilterValue.length) === localFilterValue : props.matchProp !== 'label' && valueTest.indexOf(localFilterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(localFilterValue) >= 0;
  });
}
var _default = exports["default"] = filterOptions;
//# sourceMappingURL=defaultFilterOptions.js.map